import { Navigate, Route, Routes } from "react-router-dom";

import AgentFrame from "./AgentFrame";
import { useAuth } from "./auth/AuthContext";
import { canAdministerWorkspace } from "./auth/roles";
import AccessDeniedPage from "./components/AccessDeniedPage";
import E2EAgentRunDetailPage from "./components/E2EAgentRunDetailPage";
import E2EAgentRunsPage from "./components/E2EAgentRunsPage";
import E2EAgentUsagePage from "./components/usage/E2EAgentUsagePage";
import AgentCompaniesPage from "./analyst/pages/AgentCompaniesPage";
import AgentCompanyDetailPage from "./analyst/pages/AgentCompanyDetailPage";
import AgentCompanyDocumentsPage from "./analyst/pages/AgentCompanyDocumentsPage";
import AgentCompanyRunsPage from "./analyst/pages/AgentCompanyRunsPage";
import AgentCompanyRunDetailPage from "./analyst/pages/AgentCompanyRunDetailPage";
import AgentLaunchPage from "./analyst/pages/AgentLaunchPage";
import AgentModelDetailPage from "./analyst/pages/AgentModelDetailPage";
import AgentRunRedirect from "./analyst/pages/AgentRunRedirect";
import AgentRunsPage from "./analyst/pages/AgentRunsPage";
import ApiTokenSettingsPage from "./settings/ApiTokenSettingsPage";
import CliSettingsPage from "./settings/CliSettingsPage";
import ProfileSettingsPage from "./settings/ProfileSettingsPage";
import WorkspaceUsersPage from "./settings/WorkspaceUsersPage";
import NotificationsSettingsPage from "./settings/SlackSettingsPage";
import "./analyst/styles.css";
import "./admin.css";

export default function App() {
  const auth = useAuth();
  if (!auth.canLaunch) return <AccessDeniedPage />;

  return (
    <Routes>
      <Route element={<AgentFrame />}>
        <Route index element={<Navigate to="/companies" replace />} />
        <Route path="companies" element={<AgentCompaniesPage />} />
        <Route
          path="companies/:companyId"
          element={<AgentCompanyDetailPage />}
        />
        <Route
          path="companies/:companyId/documents"
          element={<AgentCompanyDocumentsPage />}
        />
        <Route
          path="companies/:companyId/runs"
          element={<AgentCompanyRunsPage />}
        />
        <Route
          path="companies/:companyId/runs/:runId"
          element={<AgentCompanyRunDetailPage />}
        />
        <Route
          path="companies/:companyId/models/:versionId"
          element={<AgentModelDetailPage />}
        />
        <Route path="run" element={<Navigate to="/runs" replace />} />
        <Route path="new" element={<AgentLaunchPage />} />
        <Route path="runs" element={<AgentRunsPage />} />
        <Route path="runs/:runId" element={<AgentRunRedirect />} />
        <Route path="models" element={<Navigate to="/companies" replace />} />
        <Route path="models/:companyId" element={<AgentModelDetailPage />} />
        <Route
          path="settings"
          element={<Navigate to="/settings/profile" replace />}
        />
        <Route path="settings/profile" element={<ProfileSettingsPage />} />
        <Route
          path="settings/users"
          element={
            auth.canManageUsers === true ? (
              <WorkspaceUsersPage />
            ) : (
              <Navigate to="/settings/profile" replace />
            )
          }
        />
        <Route path="settings/api-tokens" element={<ApiTokenSettingsPage />} />
        <Route path="settings/cli" element={<CliSettingsPage />} />
        <Route
          path="settings/notifications"
          element={<NotificationsSettingsPage />}
        />
        <Route path="settings/slack" element={<NotificationsSettingsPage />} />
        <Route
          path="admin/usage"
          element={
            canAdministerWorkspace(auth) ? (
              <E2EAgentUsagePage />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route
          path="admin/runs"
          element={
            auth.canOperate ? <E2EAgentRunsPage /> : <Navigate to="/" replace />
          }
        />
        <Route
          path="admin/runs/:runId"
          element={
            auth.canOperate ? (
              <E2EAgentRunDetailPage />
            ) : (
              <Navigate to="/" replace />
            )
          }
        />
        <Route path="auth/callback" element={<Navigate to="/" replace />} />
        <Route path="login" element={<Navigate to="/" replace />} />
        <Route path="*" element={<Navigate to="/companies" replace />} />
      </Route>
    </Routes>
  );
}
